import { trackEvent } from 'utils';

export function trackLoginTabClick(): void {
  trackEvent('Auth', 'tab', 'login');
}

export function trackRegisterTabClick(): void {
  trackEvent('Auth', 'tab', 'register');
}

export function trackLoginSuccess(): void {
  trackEvent('Auth', 'login', 'success');
}

export function trackLoginError(): void {
  trackEvent('Auth', 'login', 'error');
}

export function trackForgotPasswordClick(): void {
  trackEvent('Auth', 'forgotPassword', 'click');
}

export function trackRegisterSuccess(): void {
  trackEvent('Auth', 'register', 'success');
}

export function trackRegisterError(): void {
  trackEvent('Auth', 'register', 'error');
}

export function trackSalutationChange(salutation: string): void {
  trackEvent('Auth', 'salutation', salutation);
}

export function trackNewsletterChange(accepted: boolean): void {
  trackEvent('Auth', 'newsletter', accepted ? 'accepted' : 'declined');
}

export function trackForgotPasswordSuccess(): void {
  trackEvent('Auth', 'forgotPassword', 'success');
}

export function trackForgotPasswordError(): void {
  trackEvent('Auth', 'forgotPassword', 'error');
}

export function trackCustomerScore(score: string): void {
  trackEvent('Score', 'Cart', score);
}

export function trackAuthFormOnCustomerScore(authForm: string): void {
  trackEvent('Cart', 'Subscribe', authForm);
}
